import * as React from 'react';
import * as styles from './styles.scss';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import { Spinner, SpinnerSize } from '@fluentui/react/lib/Spinner';
import { getThemeColorScheme } from 'owa-color-utils/lib/colorUtils';
import type { WeatherLocationPickerProps } from '../schema';
import { weatherAssetLocationPlaceholder } from '../weather.locstring.json';
import loc from 'owa-localize';
import useWeatherLocationPickerViewState from '../hooks/useWeatherLocationPickerViewState';
import LocationCommonWellItem from 'owa-location-common-well/lib/components/LocationCommonWellItem';
import LocationCommonWell from 'owa-location-common-well/lib/components/LocationCommonWell';

export default observer(function WeatherLocationPicker(props: WeatherLocationPickerProps) {
    const {
        selectedLocation,
        locationName,
        locationPersona,
        pickerRef,
        isPickerVisible,
        findControlProps,
        locationItemProps,
        titleProps,
        isLoading,
    } = useWeatherLocationPickerViewState(props);
    return (
        <div>
            <div
                className={classNames(styles.locationPickerContainer, {
                    [styles.noLocation]: !locationName || !locationPersona || isPickerVisible,
                    [styles.locationPillCustomMargin]:
                        !!locationPersona && isPickerVisible && !isLoading,
                })}>
                <Icon
                    iconName={locationPersona != undefined ? 'Poi' : 'PartlyCloudyDay'}
                    className={styles.pickerIcon}
                />
                {!!isPickerVisible ? (
                    <div ref={pickerRef}>
                        {!locationPersona && (
                            <LocationCommonWell
                                containerClassName={styles.locationPickerControl}
                                inputProps={{
                                    placeholder: loc(weatherAssetLocationPlaceholder),
                                    'aria-label': loc(weatherAssetLocationPlaceholder),
                                }}
                                onLocationsChanged={findControlProps.onItemSelected}
                                searchMode={'OnlyCities'}
                                defaultSelectedItems={selectedLocation ? [selectedLocation] : []}
                                draggableItemType={''}
                                itemLimit={1}
                                zeroQueryDisabled={true}
                                maxItemWidth={isLoading ? 100 : 110}
                                disableUseThisLocationButton={true}
                            />
                        )}
                        {locationPersona != undefined && (
                            <LocationCommonWellItem
                                viewState={locationPersona}
                                {...locationItemProps}
                                itemClassName={styles.locationItem}
                                colorScheme={getThemeColorScheme()}
                                index={1}
                                useContextMenu={true}
                                isSelected={false}
                                maxItemWidth={115}
                            />
                        )}
                    </div>
                ) : (
                    <div className={styles.locationName} {...titleProps}>
                        {locationName}
                    </div>
                )}
            </div>
            {isLoading && isPickerVisible && (
                <div className={styles.placeholder}>
                    <Spinner className={styles.loading} size={SpinnerSize.medium} />
                </div>
            )}
        </div>
    );
});
